import { useLoading } from "../Keycloak";
import { Spinner } from "./ui/Spinner";
import React from "react";

export function LoadingSpinner() {
  const { loading, showLoading } = useLoading();
  return <>{loading && showLoading ? <Spinner /> : undefined}</>;
}
